import {Box, CircularProgress} from '@mui/material'

export default function LoadingFullScreen() {
    return (
        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{height:'calc(100vh - 64px)', backgroundColor: '#ddeeff'}}>
            <CircularProgress />
        </Box>
    )
}